import { RunPropertiesBaseDestination } from '../../character-properties/run-properties-base-destination';
export class StyleRunPropertiesDestination extends RunPropertiesBaseDestination {
}
